import { render, staticRenderFns } from "./DocumentsUploadModal.vue?vue&type=template&id=158f1e0b&scoped=true"
import script from "./DocumentsUploadModal.vue?vue&type=script&lang=js"
export * from "./DocumentsUploadModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentsUploadModal.vue?vue&type=style&index=0&id=158f1e0b&prod&scoped=true&lang=css"
import style1 from "./DocumentsUploadModal.vue?vue&type=style&index=1&id=158f1e0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f1e0b",
  null
  
)

export default component.exports